import { RouteObject } from "react-router"
import { LogInView } from "./logIn.view"
import { rotas } from "../../services/router"

export enum PathRotaLogIn {
    login = "/logIn"
}

const routerLogin: RouteObject = {
    path: PathRotaLogIn.login,
    element: <LogInView/>,
}


export const navigationToItemView = ()=> rotas.navigate(PathRotaLogIn.login)

export function startRouterLogIn(){

    return routerLogin
}